import React from "react";
import { useTranslation } from "@/app/i18n/i18n-client";
import { stepsData } from "@/data/steps";

export default function Steps({ locale, slug }) {
  const { t } = useTranslation(locale, "projects");


  // ✅ Find the step data by slug
  const stepData = stepsData.find((item) => item.slug === slug);

  // ✅ Extract `stepTtl` key and ensure it resolves dynamically
  const sectionTitleKey = stepData.stepTtl; // ✅ FIX: Now correctly referencing stepTtl
  const sectionTitleTranslated = t(sectionTitleKey, `❌ Missing Title: ${sectionTitleKey}`);


  return (
    <div className="feature-area-1 space steps-section">
      <div className="container">
        <div className="title-area text-center">
          <h2 className="sec-title">{sectionTitleTranslated}</h2>
        </div>
        <div className="row gx-0 gy-40">
          {stepData.steps.map((step) => {
            const titleTranslated = t(step.title, `❌ Missing Title: ${step.title}`);
            const textTranslated = t(step.text, `❌ Missing Text: ${step.text}`);

            console.log(`🔡 Step ${step.id} Title:`, titleTranslated);
            console.log(`📝 Step ${step.id} Text:`, textTranslated);

            return (
              <div key={step.id} className="col-lg-4">
                <div className="process-card">
                  <div className="process-card-number">{step.number}</div>
                  <h4 className="process-card-title">{titleTranslated}</h4>
                  <p className="process-card-text">{textTranslated}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
